export * from './get-click-element-info';
